"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const abstract_filter_item_1 = require("./abstract-filter-item");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const lookup_selection_options_1 = require("./lookup-selection-options");
class CategoryFilterItem extends abstract_filter_item_1.AbstractFilterItem {
    constructor(id, label, onValueChange, searchable, searchCategoryName, searchCategoryFields, defaultValues, isCacheable = true, lookupSelectionType = lookup_selection_options_1.LookupSelectionOptions.MULTISELECT, convertOrToExactFilter) {
        super(id, label, onValueChange);
        this.searchable = searchable;
        this.searchCategoryName = searchCategoryName;
        this.searchCategoryFields = searchCategoryFields;
        this.defaultValues = defaultValues;
        this.isCacheable = isCacheable;
        this.lookupSelectionType = lookupSelectionType;
        this.convertOrToExactFilter = convertOrToExactFilter;
        this._values = defaultValues || [];
        this._selectedSingleValue = defaultValues && defaultValues.length ? Array.of(defaultValues[0]) : null;
    }
    get values() {
        return this._values;
    }
    set values(value) {
        this._values = value;
        this._selectedSingleValue = this._values && this._values.length ? Array.of(this._values[0]) : null;
        this.onFilterItemChange();
    }
    set singleValue(value) {
        if (!(value instanceof Array)) {
            value = value !== null ? Array.of(value) : [];
        }
        this._selectedSingleValue = value;
        this._values = value;
        this.onFilterItemChange();
    }
    get singleValue() {
        return this._selectedSingleValue;
    }
    getFilterTreeDto() {
        if (!this.values || this.values.length === 0) {
            return null;
        }
        const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
        if (this.convertOrToExactFilter) {
            filterBuilder.filterByMeasure(this.id).is(this.values.sort((a, b) => a - b).join(","));
        }
        else {
            filterBuilder.filterByCategory(this.id).in(new Set(this.values));
        }
        return filterBuilder.build();
    }
    getDefaultValue() {
        return this.lookupSelectionType === lookup_selection_options_1.LookupSelectionOptions.SINGLE_SELECT
            ? this._selectedSingleValue : this._values;
    }
    // IN case when lookup selection type only changed,
    // we need to save current combos state, but we also need to store changed filter and
    // this method just changed it without damaging current state
    changeFilterOnLookupChange() {
        this.onFilterItemChange();
    }
}
exports.CategoryFilterItem = CategoryFilterItem;
//# sourceMappingURL=category-filter-item.js.map